import MuiBottomNavigation from '@mui/material/BottomNavigation';
import MuiBottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import useNavbarItems, {
  NavbarItems,
} from '@src/main/ui/components/layout/common/Navbar/common/hooks/useNavbarItems';
import { useUserThemeContext } from '@src/main/ui/providers/user/UserThemeContextProvider';
import { FC } from 'react';

const BottomNavigation: FC = () => {
  const navbarItems: NavbarItems | undefined = useNavbarItems();
  const { theme } = useUserThemeContext();

  return (
    <>
      {navbarItems && (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 3 }} elevation={5}>
          <MuiBottomNavigation
            value={navbarItems.main.find((navbarItem) => navbarItem.isActive())}
            sx={{
              ...(theme === 'Corporate' && {
                backgroundColor: 'iberiaRed.main',
              }),
            }}
          >
            {navbarItems.main
              .filter((navbarItem) => !navbarItem.hideMobile)
              .map((navbarItem) => (
                <MuiBottomNavigationAction
                  sx={{
                    p: 0,
                    minWidth: '50px',
                    fontSize: '18px',
                    ...(theme === 'Minimalist' && {
                      '&.MuiBottomNavigationAction-root.Mui-selected': {
                        color: 'black',
                      },
                    }),
                    ...(theme === 'Corporate' && {
                      color: 'white',
                      '&.MuiBottomNavigationAction-root.Mui-selected': {
                        backgroundColor: 'white',
                        color: 'black',
                      },
                    }),
                  }}
                  key={navbarItem.text}
                  value={navbarItem}
                  label={navbarItem.text}
                  icon={navbarItem.icon && <Icon fontSize="20px" iconId={navbarItem.icon} />}
                  onClick={navbarItem.onClick}
                />
              ))}
          </MuiBottomNavigation>
        </Paper>
      )}
    </>
  );
};

export default BottomNavigation;
